import Icon from '@material-ui/icons/GroupWork';

import List from './List';
// import Show from './Show';

export default {
  name: 'comments/season',
  icon: Icon,
  list: List,
  // show: Show,
};
